import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.sass']
})
export class SpinnerComponent {
  constructor(public dialogRef: MatDialogRef<SpinnerComponent>
    , @Inject(MAT_DIALOG_DATA) public data: any) {}
}
